//
// Angular
//
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, expand, catchError } from 'rxjs/operators';
import { Observable, throwError, forkJoin, of, EMPTY } from 'rxjs';
//
// App
//
import { SharedDataService } from '../../../core/services/shared-data.service';
import {CustomerDealSummary} from '../../../shared/model/api/CustomerDealSummary';
import {DealSummaryView} from '../../../shared/model/view-model/deal-summary-view';
import { ViewConstants } from 'src/app/constants';
import * as models from  '../../../shared/model/api/models';
//
// Libraries
//
import {isNil, cloneDeep} from 'lodash-es';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { MonroneyLabel } from 'src/app/shared/model/api/MonroneyLabel';
import { ImageLabel } from 'src/app/shared/master-data/app-constant';

@Injectable({
    providedIn: 'root' 
})
export class WriteupsService {
    //private _path = '';
    private get dealerCode() {
        return this.sharedService.dealerCode;
    };
    private get userID() {
        return this.sharedService.loggedInUserId;
    };
    
    private pageSize   = 500;
    darkTheme: boolean = false;
    constructor(private httpClient: HttpClient, private sharedService : SharedDataService, private environment: EnvironmentConfiguration){}

    //
    // set the provided writeup ids status to hidden for the given logged in user
    //
    public UpdateHideUnhide(list : string[]){
        const path =
        this.environment.MST_BASE_SERVICE_URL + `user/${this.dealerCode}/preferences/${this.userID}`;
        let header = {
           // "userId" : this.userID,
            "dealerCode" : this.dealerCode,
            "leadIds" : [],
            "dealIds" : list
        };

        return this.httpClient.post(path, header);
    }


    //
    // Recursively fetch the data
    //
    public getAll(payload): Observable<DealSummaryView> {
        let currentPage = 1;
        let lastEvaluatedKey = {lastEvaluatedKey :null};
        return this.getWriteups(currentPage,lastEvaluatedKey, payload).pipe(
            expand(data => {
                if(this.hasNext(data,currentPage)){                                
                    currentPage = this.nextPage(data,currentPage);
                   lastEvaluatedKey = this.getLastEvaluatedKey(data);
                    return this.getWriteups(currentPage,lastEvaluatedKey, payload).pipe(
                        map(newResult => { 
                            if (newResult && newResult.length === 0) { // Removing the lastEvaluatedKey when the newResult (Second API call) length is 0
                                data[data.length - 1].lastEvaluatedKey = null; 
                            }
                            return [...data, ...newResult];
                        } ));
                }
                else
                    return EMPTY;
            }),
            map( o => this.formatDataforDealView(o, payload))
        );
    }
    //
    // Specify if there is still more data to be fetched
    //
    private hasNext(data:CustomerDealSummary[], currentPage) :boolean{          
        let index = data.length - 1 > 0 ? data.length - 1 : 0;
        if (
            !isNil(data) && !isNil(data[0])&&
            (
                (currentPage > 0 && data[0].dealCount && data[0].dealCount !== 0 && currentPage * 500 < data[0].dealCount)
                    || 
                (!isNil(data[index].lastEvaluatedKey))
            )
        ){
            return true;
        }
        return false;
    }

    //
    // index of the next page for writeups
    //
    private nextPage(data:CustomerDealSummary[], currentPage: number ) :number{
        let pageNo=0;
        if(!isNil(data) && !isNil(data[0]) && currentPage > 0)
        {
            if(currentPage * 500 < data[0].dealCount){
                pageNo = currentPage + 1;
            }
        }
              
        return pageNo;
    }
    //
    // last loaded key for leads
    //
    private getLastEvaluatedKey(data:CustomerDealSummary[]){
        let index = data.length - 1 > 0 ? data.length - 1 : 0;
        let lastEvaluatedValue = {
            lastEvaluatedKey: {}
        };
        if (data[index].lastEvaluatedKey) {
            lastEvaluatedValue = {
                lastEvaluatedKey: data[index].lastEvaluatedKey
            };
        }

        return lastEvaluatedValue;
    }
    //
    // actual http call to fetch the data
    //
    private getWriteups(pageNo :number, lastEvaluatedKey: any, payload):Observable<CustomerDealSummary[]>{
        //
        // SDL : Why is this a post? should be a get
        //
        let LeadsPath = this.environment.MST_BASE_SERVICE_URL +`retail-deals/dealers/${this.dealerCode}/offers/currentPagination/leads`; 
        let dealsPath = this.environment.MST_BASE_SERVICE_URL +`retail-deals/dealers/${this.dealerCode}/offers/currentPagination?dealPage=${pageNo}`; 
        let byCustomerPath = this.environment.MST_BASE_SERVICE_URL +`retail-deals/dealers/${this.dealerCode}/offers/writeUpsByCustomer?dealPage=${pageNo}`; 
        if(!isNil(payload)){
            let fromDate;
            let toDate;
            if(!isNil(payload.fromDate) && !isNil(payload.toDate)){
                fromDate=(new Date(payload.fromDate).toLocaleDateString('en-ca'));
                toDate = (new Date(payload.toDate).toLocaleDateString('en-ca'));
            }
            if(payload.activeTab == 'writeups' && isNil(payload.isAll))//being called in the initial page load and all date range filters except 'all'.
            return this.httpClient.post<CustomerDealSummary[]>(dealsPath,{...{fromDate, toDate}});
            else if(payload.activeTab == 'writeups' && !isNil(payload.isAll) && payload.isAll)//being called only for the 'all' filter in the writeups grid.
            return this.httpClient.post<CustomerDealSummary[]>(dealsPath,{});
            else if(payload.activeTab == 'by customer' && isNil(payload.isAll))//being called in the initial page load and all date range filters except 'all'.
            return this.httpClient.post<CustomerDealSummary[]>(byCustomerPath,{...{fromDate, toDate}});
            else if(payload.activeTab == 'by customer' && !isNil(payload.isAll) && payload.isAll)//being called only for the 'all' filter in the by customer grid.
            return this.httpClient.post<CustomerDealSummary[]>(byCustomerPath,{});
            else if(payload.activeTab == 'leads' && !isNil(payload.isAll) && payload.isAll)//being called only for the 'all' filter in the leads grid when refresh button is clicked.
            return this.httpClient.post<CustomerDealSummary[]>(LeadsPath,lastEvaluatedKey);
            else;//being called in the leads grid only when refresh button is clicked and passing the date filter date range as payload.
            return this.httpClient.post<CustomerDealSummary[]>(LeadsPath,{...lastEvaluatedKey, fromDate, toDate});
        }else{//being called in the initial page load of leads grid when the Leads button is clicked in the super menu. 
            return this.httpClient.post<CustomerDealSummary[]>(LeadsPath,lastEvaluatedKey);
        }
    }

    //
    // below methods may need to be moved somewhere else
    // 
    private formatDataforDealView(data: CustomerDealSummary[], payload?): DealSummaryView {
        this.darkTheme = this.sharedService.getDarkThemeValue();
        let dealSummaryData = this.setDefaulValue();
        let tempData: CustomerDealSummary[] = cloneDeep(data);
        let writeUps:CustomerDealSummary[] = [];
        let leads:CustomerDealSummary[] = [];
        let byCustomerWriteups:CustomerDealSummary[] = [];
        if(!isNil(payload) && payload.activeTab == 'by customer'){
            dealSummaryData.hiddenDeals = [];
            dealSummaryData.deals = [];
            dealSummaryData.leads = [];
            dealSummaryData.byCustomerWriteups = data;
            return dealSummaryData;
        }

        if (!isNil(tempData) && tempData.length > 0) {
            tempData.forEach(row => {
                if (row?.customer?.firstName && row?.customer?.lastName) {
                    row.customer = (<any>Object).assign({}, row.customer, {
                        customerFullName: (row.customer.firstName ?
                            row.customer.firstName.toUpperCase() : row.customer.firstName)
                            + ' ' + (row.customer.lastName ? row.customer.lastName.toUpperCase()
                                : row.customer.lastName)
                    });
                }
                if(row?.customer?.email) {
                    row.customer = (<any>Object).assign({}, row.customer, {
                        email: row.customer.email
                    });
                }
                if(row?.customer?.email && row?.customer?.customerFullName) {
                    row.customer = (<any>Object).assign({}, row.customer, {
                        customerFullNameAndEmail: row.customer.customerFullName + ' ' + row.customer.email
                    });
                }
                row.isLead = false;
                row.dealIndicator = 'WRITE-UP';
                row.formattedVisitedStatus = 'N';
                if (row?.vehicle?.modelYear && row?.vehicle?.modelMarketingName) {
                    row.vehicle = (<any>Object).assign({}, row.vehicle, {
                        modelName: row.vehicle.modelYear + ' ' + row.vehicle.modelMarketingName
                    });
                }
                if (isNil(row?.vehicle?.grade)) {
                    row.vehicle = (<any>Object).assign({}, row.vehicle, {
                        grade: ''
                    });
                }
    
                // TO DO: to be removed, when proper data is available in CustomerDealSummary
                if (row?.deal?.status) {
                    if (row.deal.status === 'PENDING REVIEW') {
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.PENDING_APPROVAL_MST
                        }); 
                        row.deal.status=ViewConstants.PENDING_APPROVAL_MST;
                        
                    } else if (row.deal.status.toUpperCase() === 'INITIATED') {
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.INITIATED
                        });
                        row.deal.status=ViewConstants.INITIATED;
                    }
                    else if (row.deal.status.toUpperCase() === 'FINALIZED') {
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
    
                            dealStatus: ViewConstants.DEAL_STATUS_FINALIZED
                       });
                       row.deal.status=ViewConstants.DEAL_STATUS_FINALIZED;
                    }
                    else if (row.deal.status.toUpperCase() === 'WRITE-UP PRICED') {
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.WRITE_UP_PRICIED
                        });
                        row.deal.status='Write up Priced';
                    }
                    else if (row.deal.status.toUpperCase() === 'SENT TO FINANCE') {
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.DEAL_STATUS_SENT_TO_FINANCE
                        });
                        row.deal.status=ViewConstants.DEAL_STATUS_SENT_TO_FINANCE;
                    }
                    else if (row.deal.status.toUpperCase() === 'DEALER APPROVED') {
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.APPROVED_MST
                        });
                        row.deal.status=ViewConstants.APPROVED_MST;
                    }
                    else if (row.deal.status.toUpperCase() === 'TRADE APPROVED') {
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.TRADE_APPROVED_MST
                        });
                        row.deal.status=ViewConstants.TRADE_APPROVED_MST;
                    }
                    else if (row.deal.status.toUpperCase() === 'EXPIRED') {
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.EXPIRED_MST
                        });
                        row.deal.status=ViewConstants.EXPIRED_MST;
                    }
                    else if (row.deal.status.toUpperCase() === 'CANCELLED') {
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.CANCELLED_MST
                        });
                        row.deal.status=ViewConstants.CANCELLED_MST;
                    }
                    else if (row.deal.status.toUpperCase() === 'DFI SUBMITTED') {
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.DFI_SUBMITTED
                        });
                        row.deal.status=ViewConstants.DFI_SUBMITTED;
                    }
                    else if (row.deal.status.indexOf('_') > 0) {
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                            dealStatus: row.deal.status.replace('_', ' ')
                        });
                    } 
                    else if (row.deal.status.toUpperCase() === ViewConstants.DEAL_STATUS_CONTRACT_APPROVED.toUpperCase()) {
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.DEAL_STATUS_CONTRACT_APPROVED
                        });
                        row.deal.status=ViewConstants.DEAL_STATUS_CONTRACT_APPROVED;
                    } else {
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                            dealStatus: row.deal.status
                        });
                    }
                }
                this.sharedService.getOnlineStatus(row.deal);
                
                // To Check if the we are getting null stock no from service then will show empty value
                if (!isNil(row) && !isNil(row.vehicle) &&
                    !isNil(row.vehicle.stockNumber) && (row.vehicle.stockNumber === "NULL" || row.vehicle.stockNumber === "null")) {
                    row.vehicle.stockNumber = ViewConstants.EMPTY_STRING;
                }
                /**
                 * Based on Thiru mail on Aug 02 2017
                 * Field name: dealType
                    Value: TradeIn (only if Trade In)
                    Value: Payment (only if APR / LEASE)
                    Value: TradeIn&Payment
    
                    Field Name: paymentType (this field will have value only if dealType is either Payment or TradeIn&Payment)
                    Value: APR or LEASE
                 */
                let tempDealType = '';
                let tempPaymentType = '';
                if (!isNil(row.deal.dealType)) {
                    tempDealType = row.deal.dealType;
                }
                if (!isNil(row.deal.paymentType)) {
                    tempPaymentType = row.deal.paymentType;
                }
    
                if ((tempDealType.toLowerCase() === 'tradein') ||
                    (tempDealType.toLowerCase() === 'tradein&payment')) {
                    tempDealType = 'Trade'
                } else {
                    tempDealType = '';
                }
    
                if (tempPaymentType.toLowerCase() === 'apr') {
                    tempPaymentType = 'Finance';
                } else if (tempPaymentType.toLowerCase() === 'lease') {
                    tempPaymentType = 'Lease';
                } else if (tempPaymentType.toLowerCase() === 'cash') {
                    tempPaymentType = 'Cash';
                }
    
                let offerType = '';
                if (tempDealType !== '' && tempPaymentType !== '') {
                    offerType = tempDealType + ' - ' + tempPaymentType;
                } else if (tempDealType !== '') {
                    offerType = tempDealType;
                } else if (tempPaymentType !== '') {
                    offerType = tempPaymentType;
                }
    
                row.estimatedOffer = (<any>Object).assign({}, {}, {
                    dealtype: offerType
                });
    
                // This condition is not needed in new Console ui we have it in old UI. 
                // Because of this initiated and expired count may not match with new and old UI

                // if(!isNil(row) && isNil(row.deal.dealType) && !isNil(row.deal.status) && row.deal.status === "EXPIRED")
                //     row.dealStatus = (<any>Object).assign('', row.dealStatus, { dealStatus: 'INITIATED'});
                
                // To Assign Lead Type
                // if (!isNil(row.origin) && !isNil(row.deal.sourceSystem) && !isNil(row.lead)
                //     && !isNil(row.lead.leadId)
                //     && row.origin.toUpperCase() === 'DG' && row.deal.sourceSystem.toUpperCase() === 'DG') {
                    if (!isNil(row.lead) && !isNil(row.lead.origin) && !isNil(row.lead.leadId)
                    //&& row.lead.origin.toUpperCase() === 'DG'
                     ) {
                    row.isLead = true;
                    row.dealIndicator = 'LEAD';//"ConfirmAvailability"EQUITY
                    let tempLeadType: string = '';
                    if (row.lead.leadType.toUpperCase() === 'PRICING') {
                        tempLeadType = ViewConstants.LEAD_TYPE_VEHICLE_SELLING_PRICE;
                    } else if (row.lead.leadType.toUpperCase() === 'DEALER') {
                        tempLeadType = 'Dealer Contact';
                    } else if (row.lead.leadType.toUpperCase() === 'EQUITY') {
                        tempLeadType = 'Equity';
                    } else if (row.lead.leadType.toUpperCase() === 'CONFIRMAVAILABILITY') {
                        tempLeadType = 'Confirm Availability';
                    } else if (row.lead.leadType.toUpperCase() === 'OFFER') {
                        tempLeadType = 'Offer';
                    } else if (row.lead.leadType.toUpperCase() === 'PAYMENTESTIMATION') {
                        tempLeadType = ViewConstants.LEAD_TYPE_PAYMENT;
                    } else if (row.lead.leadType.toUpperCase() === 'SHAREDSAVES') {
                        tempLeadType = ViewConstants.LEAD_TYPE_SHARED_SAVES;
                    } else if (row.lead.leadType.toUpperCase() === 'DEAL') {
                        tempLeadType = ViewConstants.LEAD_TYPE_DEAL;
                    }
                    row.estimatedOffer = (<any>Object).assign({}, {}, {
                        dealtype: tempLeadType
                    });
    
                    row.updatedDate = (<any>Object).assign('', row.updatedDate, {
                        updatedDate: this.formatDate(row.lead.updatedDate),
                        updatedDateAsDate: new Date(row.lead.updatedDate)
                    });
    
                    if (!isNil(row.lead.origin)) {
                        row.updatedOrigin = (<any>Object).assign('', row.updatedOrigin, {
                            updatedOrigin: row.lead.origin
                        });
    
                        row.updatedBy = (<any>Object).assign('', row.updatedBy, {
                            updatedBy: row.lead.origin
                        });
    
                        row.dealStatus = (<any>Object).assign('', row.dealStatus, {
                            dealStatus: ''
                        });
                    }
    
                    if (!isNil(row.lead.visitedStatus)) {
                        if (row.lead.visitedStatus.toLowerCase() === 'visited') {
                            row.formattedVisitedStatus = 'Y';
                        }
                    }
    
                   
                }
    
                // For MST deals Assign origin
                if (!isNil(row.deal.origin)) {
                    row.updatedOrigin = (<any>Object).assign('', row.updatedOrigin, {
                        updatedOrigin: row.deal.origin
                    });
                }
    
                if (!row.isLead && isNil(row.deal.origin)) {
                    row.updatedOrigin = (<any>Object).assign('', row.updatedOrigin, {
                        updatedOrigin: 'MST'
                    });
                }
    
    
                // For Trade Deal type will show the trade vin(old vin).
                // If we have more than one trade in vin
                // then will show the first vin.
                /**
                 *Ask per discussion with Raghu, changing the logic  
                 */
                if (offerType === 'Trade') {
                    // if (row.tradeIns && row.tradeIns.length > 0) {
                    //     row.vehicle = (<any>Object).assign({}, row.vehicle, {
                    //         vin: row.tradeIns[0].vin
                    //     });
                    // } else {
                    //     row.vehicle = (<any>Object).assign({}, row.vehicle, {
                    //         vin: ''
                    //     });
                    // }
                    if (!(!isNil(row) && !isNil(row.vehicle) && !isNil(row.vehicle.vin))) {
                        row.vehicle = (<any>Object).assign({}, row.vehicle, {
                            vin: ViewConstants.EMPTY_STRING, 
                            stockNumber: ViewConstants.EMPTY_STRING,
                            modelMarketingName: ViewConstants.EMPTY_STRING,
                            modelYear: ViewConstants.EMPTY_STRING
    
                        });
                    }
                }
    
                // To Format Visited status
    
                if (!isNil(row.deal.visitedStatus)) {
                    if (row.deal.visitedStatus.toLowerCase() === 'visited') {
                        row.formattedVisitedStatus = 'Y';
                    }
                }
    
                // To update sale type
                if(!isNil(row?.vehicle?.type)) {
                    if(row.vehicle.type.toLowerCase() === 'certified') {
                        row.vehicle.type = 'Certified';
                    }
                    else if(row.vehicle.type.toLowerCase() === 'new') {
                        row.vehicle.type = 'New';
                    }
                    else if(row.vehicle.type.toLowerCase() === 'used') {
                        row.vehicle.type = 'Used';
                    }
                }
    
                if (!isNil(row?.deal?.updatedDate)) {
                    row.updatedDate = (<any>Object).assign('', row.updatedDate, {
                        updatedDate: this.formatDate(row.deal.updatedDate),
                        updatedDateAsDate: new Date(row.deal.updatedDate)
                    });
                }
    
                if (!isNil(row?.deal?.salesAssociate?.updatedBy)) {
                    row.updatedBy = (<any>Object).assign('', row.updatedBy, {
                        updatedBy: row.deal.salesAssociate.updatedBy
                    });
                }
    
                if(!isNil(row?.deal?.salesAssociate?.createdBy)) {
                    row.createdBy = (<any>Object).assign('', row.createdBy, {
                        createdBy: row.deal.salesAssociate.createdBy
                    });
                }
    
                if(!isNil(row?.deal?.salesAssociate?.salesConsultant)) {
                    row.deal.salesAssociate.salesConsultant = row.deal.salesAssociate.salesConsultant.split(' ').map( w =>  w.substring(0,1).toUpperCase()+ w.substring(1)).join(' ');
                    row.salesConsultant = (<any>Object).assign('', row.salesConsultant, {
                        salesConsultant: row.deal.salesAssociate.salesConsultant
                    });
                }

                if(row.vehicle){
                    row.vehicle.vin_stocknum = (row.vehicle.vin || '') + (row.vehicle.stockNumber || '');
                    if(row.vehicle.carJellyImgURL) { 
                        row.vehicle.carJellyImgURL=this.imageExists(row.vehicle.carJellyImgURL)?row.vehicle.carJellyImgURL: (this.darkTheme ? ImageLabel.ICON_NO_IMAGE_NIGHT_HREF : ImageLabel.ICON_NO_IMAGE_HREF);
                    }
                }
                if(!isNil(row) && row.isLead) 
                    leads.push(row); 
                else 
                    writeUps.push(row);
                
            });
            writeUps.forEach(dt => {
                if (dt.deal.dealType == 'TRADEIN' 
                    && dt.vehicle  && (dt.vehicle.vin == null || dt.vehicle.vin == '')){
                    dt.vehicle.type ='Trade';
                }
                
              });
            dealSummaryData.hiddenDeals = writeUps.filter( e => e.deal.isHidden);
            dealSummaryData.deals = writeUps.filter( e => !e.deal.isHidden);;
            dealSummaryData.leads = leads;
        }     
        return dealSummaryData;
    }

    imageExists(url) {
        // this below code is commented in master branch to fix image not loading issue in grdd in production.
        // var image = new Image();
        // image.src = url;
        if (isNil(url) || url?.includes('undefined') || url?.includes('Object') || url === '') {
            return false;
        }
        return true;
    }

    /**
     * Method used to format the date value (if the value is less
     * than 9 then will 0 before the value)
     */
    private formatDateValue(value) {
        return value > 9 ? '' + value : '0' + value;
    }
    private  formatDate(date, convertUTC: boolean = true) {
        let modifiedDate = new Date(date);
        let updatedDate: any = {};
        if(convertUTC) {
            modifiedDate.setHours(modifiedDate.getHours() - 8);
        }
        let day = this.formatDateValue(modifiedDate.getDate());
        let month = this.formatDateValue(modifiedDate.getMonth() + 1);
        let year = modifiedDate.getFullYear();
        let hours = modifiedDate.getHours();
        let minutes = this.formatDateValue(modifiedDate.getMinutes());
        let h = (hours % 12) || 12;
        let ampm = hours < 12 ? 'AM' : 'PM';
        let timeString = this.formatDateValue(h) + ':' + minutes.toString() + ' ' + ampm;
        // row.updatedDate = (<any>Object).assign('', row.updatedDate, {
        //     updatedDate: timeString + '&nbsp;&nbsp;&nbsp; ' + month + '.' + day + '.'
        //     + year
        // });
        updatedDate = timeString + ' ' + month + '.' + day + '.'
            + year;
        return updatedDate;
    }
    /*
     * Method used to set the default initial state of DealSummaryState
     */
    private setDefaulValue(): DealSummaryView {
        //let dataFormatter = <SharedFunctionService>new Object();
        let dealSummaryData: DealSummaryView = <DealSummaryView>new Object();
        dealSummaryData.deals = [];
        dealSummaryData.hiddenRecords = {};
        dealSummaryData.userView = {};
        dealSummaryData.successMessage = '';
        dealSummaryData.failureMessage = '';
        dealSummaryData.globalSearchFilterValue = '';
        dealSummaryData.originalDeals = [];
        dealSummaryData.customerLeads = [];
        dealSummaryData.byCustomerWriteups = [];
        return dealSummaryData;
    }

    //
    // HTTP call to fetch the Monroney Label Data
    //
    public getMonroneyLabelData(vehicleData: MonroneyLabel): Observable<any> {
        let path: string;
        if (!isNil(vehicleData) && vehicleData.type.toLowerCase() === ViewConstants.VEHICLE_TYPE_NEW) { // Service Call to fetch Monroney Label for NEW Vehicles
            path = this.environment.MST_BASE_SERVICE_URL + `dealers/${this.dealerCode}/monroney/label?vin=${vehicleData.vin}`;

            return this.httpClient.get<any>(path, { responseType: 'text' as 'json' })
                .pipe(
                    map((response: any) => response),
                    catchError(err => this.handleErrorDetail(err)))
        } else if (!isNil(vehicleData) && vehicleData.type.toLowerCase() === ViewConstants.VEHICLE_TYPE_CERTIFIED) { // Service Call to fetch Monroney Label for Certified Vehicles
            if (!this.sharedService.isUVIEndpoint) {
                path = this.environment.BASE_SERVICE_URL + `/dealer-inventory/usedvehicles/${vehicleData.vin}`;
            } else {
                path = this.environment.USED_VEHICLE_BASE_SERVICE_URL + `/used-vehicle-inventory/vehicles/${vehicleData.vin}`
            }
            return this.httpClient.get<any>(path)
                .pipe(
                    map((response: any) => response),
                    catchError(err => this.handleErrorDetail(err)))
        }
    }

    //
    // HTTP call to fetch the Used Vehicle Data
    //
    public getUsedVehicleData(vehicleData):Observable<any>{
        let path: string;
        if (!isNil(vehicleData)) {
            if(this.sharedService.isUVIEndpoint) { // UVI Endpoint is TRUE 
                path = this.environment.USED_VEHICLE_BASE_SERVICE_URL + `/used-vehicle-inventory/vehicles/${vehicleData.vin}`;
            } else { // UVI Endpoint is FALSE
                path = this.environment.BASE_SERVICE_URL + `/dealer-inventory/usedvehicles/${vehicleData.vin}`;
            }
            return this.httpClient.get<any>(path)
                .pipe(
                    map((response: any) => response),
                    catchError(err => this.handleErrorDetail(err)))
        }      
    }

    //
    // HTTP call to fetch the Reprint Declination Form Data
    //
    public getReprintDeclinationFormData(vehicleData): Observable<any> {
        if (!isNil(vehicleData)) {
            // Fetching Protection Products Data
            let path = this.environment.MST_BASE_SERVICE_URL + `digitalfi/dealers/${this.dealerCode}/worksheet/view`;
            return this.httpClient.post<any>(path, vehicleData)
                .pipe(
                    map((response: any) => response),
                    catchError(err => this.handleErrorDetail(err))
                )
        }
    }

    //
    // HTTP call to fetch the Deal Offer Details
    //
    public SummaryDealOffersLoadData(vehicleData): Observable<any> {
        if (!isNil(vehicleData)) { console.log(vehicleData);
            // Fetching Writeup details Data
            let path = this.environment.MST_BASE_SERVICE_URL + `retail-deals/dealers/${this.dealerCode}/offers/${vehicleData.dealTransactionId}`;
            return this.httpClient.get(path)
                .pipe(
                    map(response => response),
                    catchError(err => this.handleErrorDetail(err))
                )
        }
    }

    //
    // HTTP call to fetch the summary vspec load details
    //
    public SummaryVspecLoadData(vehicleVin): Observable<models.DownloadVspec> {
        
        if (!isNil(vehicleVin)) {
            // Fetching Writeup details Data
            let path = this.environment.BASE_SERVICE_URL + `/dealer-inventory/vehicles/${vehicleVin}`;
            return this.httpClient.get<any>(path)
            .pipe(
                map((response: models.DownloadVspec) => response),
                catchError(err => this.handleErrorDetail(err)))
        }
    }

    public getCustomerDetails(): Observable<models.CustomerInfo> {
        
            // Fetching Writeup details Data
            let path = this.environment.MST_BASE_SERVICE_URL + `customers/${this.sharedService.customerId}`;
            return this.httpClient.get<any>(path)
            .pipe(
                map((response: models.CustomerInfo) => response),
                catchError(err => this.handleErrorDetail(err)))
        
    }
    public getPaymentDetails(data): Observable<models.CustomerInfo> {
        
        // Fetching Writeup details Data
        let path = this.environment.MST_BASE_SERVICE_URL + `payment-nexgen/dealers/${this.sharedService.dealerCode}/payments`;
        return this.httpClient.post<any>(path,data)
        .pipe(
            map((response: models.CustomerInfo) => response),
            catchError(err => this.handleErrorDetail(err)))
    }


    public getDealDetailsForInitiatedModal(data): Observable<models.CustomerInfo> {
        
        // Fetching Writeup details Data
        let path = this.environment.MST_BASE_SERVICE_URL + `retail-deals/dealers/${this.dealerCode}/offers/${data.deal.dealTransactionId}`;
        return this.httpClient.get<any>(path)
        .pipe(
            map((response: models.CustomerInfo) => response),
            catchError(err => this.handleErrorDetail(err)))
    
}

    public getVehicleDetailsForInitiatedModal(data): Observable<models.VehicleDeal> {

        let path: string;
        if (data.type === 'Used' || data.type === 'Certified' || data.type === 'used' || data.type === 'certified' ) {
            if(this.sharedService.isUVIEndpoint) { // UVI Endpoint is TRUE 
                path = this.environment.USED_VEHICLE_BASE_SERVICE_URL + `/used-vehicle-inventory/vehicles/${data.vin}`;
            } else { // UVI Endpoint is FALSE
                path = this.environment.USED_VEHICLE_BASE_SERVICE_URL + `/dealer-inventory/usedvehicles/${data.vin}`;
            }
        }else if(data.type === 'New' || data.type === 'new'){
            path = this.environment.BASE_SERVICE_URL + `/dealer-inventory/vehicles/${data.vin}`;
        }
        return this.httpClient.get<any>(path).pipe(
                    map((response: models.VehicleDeal) => response),
                    catchError(err => this.handleErrorDetail(err)));

    }

    //
    // HTTP call to Fetch the V-Spec Token
    //
    public SummaryVspecOpenInBrowser(data): Observable<any> {
        let vehicleData: models.vSpecBrowser = {};
        if(!isNil(data) && !isNil(data.selectedWriteUp.writeUps)) {
                vehicleData.vehicles = [];
                vehicleData.id = data.selectedWriteUp.writeUps[0].customer.email;
                vehicleData.custname = data.selectedWriteUp.writeUps[0].customer.customerFullName;
                vehicleData.dealerCd = data.selectedWriteUp.writeUps[0].customer.dealerCode;
                vehicleData.dealerPersonnel = {};
                vehicleData.dealerPersonnel.dealerCd = this.sharedService.dealerCode;
                vehicleData.dealerPersonnel.name = this.sharedService.getDealerNameFromToken();
                vehicleData.dealerPersonnel.email = this.sharedService.setAndGetValues('dealerPersonnelEmail', false, null);
                vehicleData.dealerPersonnel.phoneNo = this.sharedService.setAndGetValues('dealerPhoneNumberFromToken', false, null);
                vehicleData.dealerPersonnel.phoneType = 'work';
                vehicleData.dealerPersonnel.zipCode = this.sharedService.dealerZipCode;
                if(data.selectedWriteUp.VSpecNotes !== '') { // Message will not be empty if the selected option was 'Custom Landing Page'
                    vehicleData.message = data.selectedWriteUp.VSpecNotes; 
                } else { // Message will be empty if the selected option was 'Open in Browser'
                    vehicleData.message = 'MANAGEMENT_CONSOLE_OPEN_NEW_BROWSER'; // Hard Coding as of now as the empty string is resulting in an API error
                }
                for(let i=0; i<data.selectedWriteUp.writeUps.length; i++) {
                    let offer = {...data.selectedWriteUp.writeUps[i].deal.offer};
                    offer.paymentType = data.selectedWriteUp.writeUps[i].deal.paymentType;
                    offer.writeUpStatus = data.selectedWriteUp.writeUps[i].deal.status;
        
                    vehicleData.vehicles.push(
                        {
                            grade: data.selectedWriteUp.writeUps[i].vehicle.grade,
                            marketingSeries: data.selectedWriteUp.writeUps[i].vehicle.series,
                            model: {
                                modelCd: data.selectedWriteUp.writeUps[i].vehicle.modelCode,
                                marketingName: data.selectedWriteUp.writeUps[i].vehicle.modelMarketingName
                            },
                            media: [
                                {
                                    type: 'exterior',
                                    href: data.selectedWriteUp.writeUps[i].vehicle.carJellyImgURL
                                }
                            ],
                            price: {
                                totalMsrp: data.selectedWriteUp.writeUps[i].deal.offer.dealerSellingPrice
                            },
                            year: data.selectedWriteUp.writeUps[i].vehicle.modelYear,
                            unitId: 123456789, // ToDO - Hard coding the value for now
                            vin: data.selectedWriteUp.writeUps[i].vehicle.vin,
                            offer: offer,
                            protectionProducts: [],
                            dealTransactionId: data.selectedWriteUp.writeUps[i].deal.dealTransactionId,
                            vehicleType: data.selectedWriteUp.writeUps[i].vehicle.type,
                            brand: data.selectedWriteUp.writeUps[i].vehicle.brand
                        }
                    )
        
                }
                vehicleData.vehicles.forEach(vehicle => {
                    data.productsData.forEach(product => {
                        if(vehicle.dealTransactionId === product.dealTransactionId) {
                            vehicle.protectionProducts = [...product.protectionProducts]
                        }
                    })
                })

                vehicleData.vehicles.forEach(vehicle => {
                    delete vehicle.dealTransactionId;
                 });

            let path = this.environment.BASE_SERVICE_URL + `/d2c-comms/leads/vspec`;
                return this.httpClient.post<any>(path, vehicleData)
                    .pipe(
                        map((response: any) => response),
                        catchError(err => this.handleErrorDetail(err))
                    )

        }                      
    }

    getProtectionProducts(data: any): Observable<any> {
        let responseArray: any = [];
        if(data?.length > 0) {
            data.forEach(element => responseArray.push(this.httpClient.get(element)));
            return forkJoin(responseArray);
        }else{
            return responseArray;
        }
    }


    handleErrorDetail(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = error.error.errorCode;
        }
        if(errorMessage && errorMessage.length <= 0)
          errorMessage = `Error: ${error.message}`;
        return throwError(errorMessage);
    }

    verifyAddress(custAddress)
    {
        return new Promise((resolve, reject) => {
			 
				if ((custAddress.street === '' || custAddress.street === undefined || custAddress.street === null)  && (custAddress.city === '' || custAddress.city === undefined || custAddress.city === null) && (custAddress.state === '' || custAddress.state === undefined || custAddress.state === null) && (custAddress.zipCode === '' || custAddress.zipCode === undefined || custAddress.zipCode === null)) {
					resolve(custAddress);
				}
				else {
					custAddress.street = custAddress.street === undefined ? '' : custAddress.street;
					custAddress.city = custAddress.city === undefined ? '' : custAddress.city;
					custAddress.state = custAddress.state === undefined ? '' : custAddress.state;
					custAddress.zipCode = custAddress.zipCode === undefined ? '' : custAddress.zipCode;

					//.map(res => res.json())
					// '&county=' + custAddress.county +
					this.httpClient.get(this.environment.MST_BASE_SERVICE_URL + 'dealers/' + this.dealerCode + '/address-verification?address=' + custAddress.street +  '&city=' + custAddress.city + '&state=' + custAddress.stateCode + '&zipCode=' + custAddress.zipCode + '&country=USA')
						.pipe(
							map((res: any) => {
								return res;
							}),
							catchError((res: any) => {
								if (res.hasOwnProperty('message') && (res.message.toString().toLowerCase().indexOf(ViewConstants.timeoutErrorCode) > -1)) {
									return of(ViewConstants.timeoutErrorCode);
								} else {
									return of(res);
								}
							})
						)
						.subscribe(data => {
							if (data!==undefined && data.Records !== undefined && data.Records.length > 0) {
								const resultsCodes = data.Records[0].Results.split(',');
								const resultsCodesFromDoc = Object.keys(ViewConstants.addressResultsCodes);
								const finalResultCodes = resultsCodes.filter(item =>
									resultsCodesFromDoc.indexOf(item) >= 0);
								if (finalResultCodes.length > 0) {
                                    const systemAddress = {...data.Records[0]};
                                    resolve(systemAddress);
								}else {
									const systemAddress = {...data.Records[0]};
                                        resolve(systemAddress);
								}
							} 
                            else {
								resolve(custAddress);
							}
						}, error => {
							resolve(custAddress);
						});
				
			} 
		});
    }
    
}